import React, { useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import validator from 'validator';

import Navbar from '../../components/navbar/navbar'
import FooterTop from '../../components/footer-top'
import Footer from '../../components/footer'
import toast from 'react-hot-toast';
import { registerUser } from '../../services/ApiServices';
import logo from '../../assets/img/logo.png'

export default function CreateAccount({ setCreateAccount }: any) {
    const navigate = useNavigate();
    const initialState = {
        fname: "",
        pnumber: "",
        address: "",
        email: "",
        password: "",
        confirmPwd: "",
        userType: "Owner",
        pnumberLength: "",
        emailValid: "",
        pwdLength: ""
    }
    const [registerData, setRegisterData] = useState(initialState);
    const [confirmPwdError, setConfirmPwdError] = useState<boolean>(false);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState(initialState);

    console.log("registerData", registerData);

    const handleRegisterData = (e: any) => {
        setError({ ...error, [e.target.name]: "" });
        if (e.target.name === "confirmPwd") {
            setConfirmPwdError(false);
        }
        if (e.target.name === "pnumber") {
            if (!e.target.value) {
                setError({ ...error, pnumber: "Phone Number is required" })
            } else if (e.target.value && e.target.value.length < 10) {
                if (e.target.value.length < 10) {
                    setError({ ...error, pnumberLength: "The phone no. must be 10 characters.", pnumber: "" })
                }
            } else if (e.target.value && e.target.value.length === 10) {
                setError({ ...error, pnumber: "" });
                setError({ ...error, pnumberLength: "" });
            }
        }
        if (e.target.name === "email") {
            if (!e.target.value) {
                setError({ ...error, email: "" });
            } else if (e.target.value && !validator.isEmail(e.target.value)) {
                setError({ ...error, email: "", emailValid: "Please enter a valid email" });
            } else {
                setError({ ...error, email: "", emailValid: "" });
            }
        }
        if (e.target.name === "password") {
            if (!e.target.value) {
                setError({ ...error, password: "" });
            } else if (e.target.value && e.target.value?.length < 8) {
                setError({ ...error, password: "", pwdLength: "The password must be at least 8 characters." });
            } else {
                setError({ ...error, password: "", pwdLength: "" });
            }
        }
        if (e.target.name === "fname") {
            setError({ ...error, fname: "" });
        }
        if (e.target.name === "userType") {
            setError({ ...error, userType: "" });
        }
        if (e.target.name === "address") {
            setError({ ...error, address: "" });
        }
        setRegisterData({ ...registerData, [e.target.name]: e.target.value });
    }

    const validation = (e: any) => {
        e.preventDefault();
        if (!registerData?.fname) {
            setError({ ...error, fname: "Full name is required" })
            return;
        }
        if (!registerData?.pnumber) {
            setError({ ...error, pnumber: "Phone Number is required" })
            return;
        }
        if (registerData?.pnumber && registerData?.pnumber.length < 10) {
            setError({ ...error, pnumberLength: "The phone no. must be 10 characters." })
            return;
        }
        if (!registerData?.email) {
            setError({ ...error, email: "email is required" })
            return;
        }
        if (registerData?.email && !validator.isEmail(registerData?.email)) {
            setError({ ...error, emailValid: "Please enter a valid email" })
            return;
        }
        if (!registerData?.password) {
            setError({ ...error, password: "Password is required" })
            return;
        }
        if (registerData?.password && registerData?.password?.length < 8) {
            setError({ ...error, pwdLength: "The password must be at least 8 characters." })
            return;
        }
        if (registerData?.password !== registerData?.confirmPwd) {
            setConfirmPwdError(true)
            return;
        }
        if (!registerData?.userType) {
            setError({ ...error, userType: "Select who You Are?" })
            return;
        }
        registerUserApiCall()
    }

    const registerUserApiCall = () => {
        // e.preventDefault()
        setLoading(true);
        const data = new FormData();

        data.append('username', registerData?.fname);
        data.append('email', registerData?.email);
        data.append('password', registerData?.password);
        data.append('password_confirmation', registerData?.confirmPwd);
        data.append('type', registerData?.userType);
        data.append('phoneno', registerData?.pnumber);
        data.append('address', registerData?.address);
        registerUser(data).then((res) => {
            console.log("create account response", res);

            if (res?.status === "success") {
                const profile = res
                console.log("login---------->", profile);
                localStorage?.setItem('userProfile', JSON.stringify(res.userdata));
                localStorage?.setItem('api_token', res.token);
                toast.success(profile.message);
                navigate("/")
                setRegisterData(initialState)
                setCreateAccount(false)
                setLoading(false);
            } else if (res?.validaterror === "1") {
                setLoading(false);
                toast.error(res?.message?.email[0])
            } else {
                setLoading(false);
                toast.error("Something went wrong")
            }
        })
    }
    return (
        <>
            <div className="card border-0 rounded-4">

                <div className="simple-form">
                    <div className="form-header text-center mb-5">
                        <h4 className="fs-2">Create An Account</h4>

                        <div className="effco-logo mb-2">
                            <Link className="d-flex align-items-center justify-content-center" to="/">
                                <img src={logo} height={50} width={"40%"} />
                                {/* <svg width="90" height="90" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M15.8797 15.375C15.9797 15.075 15.9797 14.775 15.9797 14.475C15.9797 13.775 15.7797 13.075 15.4797 12.475C14.7797 11.275 13.4797 10.475 11.9797 10.475C11.7797 10.475 11.5797 10.475 11.3797 10.575C7.37971 11.075 4.67971 14.575 2.57971 18.075L10.8797 3.675C11.3797 2.775 12.5797 2.775 13.0797 3.675C13.1797 3.875 13.2797 3.975 13.3797 4.175C15.2797 7.575 16.9797 11.675 15.8797 15.375Z" fill="currentColor" />
                                        <path opacity="0.3" d="M20.6797 20.6749C16.7797 20.6749 12.3797 20.275 9.57972 17.575C10.2797 18.075 11.0797 18.375 11.9797 18.375C13.4797 18.375 14.7797 17.5749 15.4797 16.2749C15.6797 15.9749 15.7797 15.675 15.7797 15.375V15.2749C16.8797 11.5749 15.2797 7.47495 13.2797 4.07495L21.6797 18.6749C22.2797 19.5749 21.6797 20.6749 20.6797 20.6749ZM8.67972 18.6749C8.17972 17.8749 7.97972 16.975 7.77972 15.975C7.37972 13.575 8.67972 10.775 11.3797 10.375C7.37972 10.875 4.67972 14.375 2.57972 17.875C2.47972 18.075 2.27972 18.375 2.17972 18.575C1.67972 19.475 2.27972 20.475 3.27972 20.475H10.3797C9.67972 20.175 9.07972 19.3749 8.67972 18.6749Z" fill="currentColor" />
                                    </svg> */}
                            </Link>
                        </div>
                    </div>
                    <form>

                        <div className="row">

                            <div className="col-lg-6 col-md-6">
                                <div className="form-group mb-3">
                                    <label className='mb-2'>Full Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="John Smith"
                                        value={registerData?.fname}
                                        name='fname'
                                        onChange={handleRegisterData}
                                    />
                                    {error?.fname && <p style={{ color: "red" }}>{error?.fname}</p>}
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 mb-3">
                                <div className="form-group">
                                    <label className='mb-2'>Phone Number</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="123 456 7898"
                                        value={registerData?.pnumber}
                                        name='pnumber'
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            // Allow only digits and one leading +
                                            value = value.replace(/(?!^\+)[^\d]/g, "");
                                            handleRegisterData({ target: { name: "pnumber", value: value } });
                                        }}
                                        // onChange={handleRegisterData}
                                        maxLength={10}
                                    />
                                    {error?.pnumber && <p style={{ color: "red" }}>{error?.pnumber}</p>}
                                    {error?.pnumberLength && <p style={{ color: "red" }}>{error?.pnumberLength}</p>}
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 mb-3">
                                <div className="form-group">
                                    <label className='mb-2'>Address(Optional)</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        placeholder="123, Waterfall Street, Irving, Texas"
                                        value={registerData?.address}
                                        name='address'
                                        onChange={handleRegisterData}
                                    />
                                    {error?.address && <p style={{ color: "red" }}>{error?.address}</p>}
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 mb-3">
                                <div className="form-group">
                                    <label className='mb-2'>Email</label>
                                    <input
                                        type="email"
                                        className="form-control"
                                        placeholder="john.smith@commercialspc.com"
                                        value={registerData?.email}
                                        name='email'
                                        onChange={handleRegisterData}
                                    />
                                    {error?.email && <p style={{ color: "red" }}>{error?.email}</p>}
                                    {error?.emailValid && <p style={{ color: "red" }}>{error?.emailValid}</p>}
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 mb-3">
                                <div className="form-group">
                                    <label className='mb-2'>Password</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        placeholder="*******"
                                        value={registerData?.password}
                                        name='password'
                                        onChange={handleRegisterData}
                                    />
                                    {error?.password && <p style={{ color: "red" }}>{error?.password}</p>}
                                    {error?.pwdLength && <p style={{ color: "red" }}>{error?.pwdLength}</p>}
                                </div>
                            </div>

                            <div className="col-lg-6 col-md-6 mb-3">
                                <div className="form-group">
                                    <label className='mb-2'>Confirm Password</label>
                                    <input
                                        type="password"
                                        className="form-control"
                                        placeholder="*******"
                                        value={registerData?.confirmPwd}
                                        name='confirmPwd'
                                        onChange={(e) => {
                                            handleRegisterData(e)
                                            if (e.target.value !== registerData?.password) {
                                                setConfirmPwdError(true)
                                            } else {
                                                setConfirmPwdError(false)
                                            }
                                        }}
                                    />
                                    {confirmPwdError && <p style={{ color: "red" }}>Password Not Match.</p>}
                                </div>

                            </div>


                            <div className="col-lg-6 col-md-6 mb-3">
                                <div className="form-group">
                                    <label className='mb-2'>I am a</label>
                                    <select className="form-control" onChange={handleRegisterData} name='userType' value={registerData?.userType}>
                                        <option value={"Owner"}>Owner</option>
                                        <option value={"Broker"}>Broker</option>
                                        <option value={"Agent"}>Agent</option>
                                        <option value={"Manager"}>Manager</option>
                                        <option value={"Other"}>Other</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                        <div className="form-group">
                            <button
                                type="submit"
                                className="btn btn-primary full-width fw-medium"
                                onClick={(e) => validation(e)}
                                disabled={isLoading}
                            >
                                {isLoading ? "Creating..." : <>Create Account<i className="fa-solid fa-arrow-right-long ms-2"></i></>}
                            </button>
                        </div>
                    </form>
                </div>
                {/* <div className="modal-divider"><span>Or SignUp via</span></div>
                            <div className="social-login mb-3">
                                <ul>
                                    <li><Link to="#" className="btn connect-fb"><i className="ti-facebook"></i>Facebook</Link></li>
                                    <li><Link to="#" className="btn connect-google"><i className="ti-google"></i>Google+</Link></li>
                                </ul>
                            </div> */}
            </div>
            {/* </div> */}
            {/* </div> */}
            {/* </div> */}
            {/* </section> */}

            {/* <FooterTop bg="theme-bg" />

            <Footer /> */}
        </>
    )
}
